import * as React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

 const  PasswordPolicySettings = ({data, onFieldChange, onSave}) => {    //  const [row, setRow] = useState(LicenceData);

    return (
        <div style={{width:800}}>
            <div style={{display: 'flex', flexDirection: 'column', border: '1px solid #d3d3d3', padding: 5, borderRadius: 5}}>
                <div style={{marginTop:1}}>
                    <Checkbox
                        id='enablePasswordHistory'
                        checked={data.enablePasswordHistory}
                        onChange={(event, value) => onFieldChange( event.target.checked, event.target.id)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    /> Enable Password History
                </div>
                <div style={{marginLeft:50}}>
                    <TextField
                        // style={{marginTop: 5}}
                        disabled={!data.enablePasswordHistory}
                        id="nbOfPasswordInHistory" 
                        label="Number of password in history" 
                        variant="outlined"
                        className="TextField"
                        value={data.nbOfPasswordInHistory}
                        onChange={(event, value) => onFieldChange( event.target.value, event.target.id)}
                        InputLabelProps={{ inputMode: 'numeric', 
                            shrink: true,
                        }}
                    />
                </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', border: '1px solid #d3d3d3', padding: 5, borderRadius: 5, marginTop: 20}}>
                <div style={{marginTop:1}}>
                    <Checkbox
                        id="enablePasswordDuration"
                        checked={data.enablePasswordDuration}
                        onChange={(event, value) => onFieldChange( event.target.checked, event.target.id)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    /> Enable Password Duration
                </div>
                <div style={{marginLeft:50}}>
                    <TextField
                        // style={{marginTop: 5}}
                        disabled={!data.enablePasswordDuration}
                        id="passwordDurationInDays" 
                        label="Password Duration in Days" 
                        variant="outlined"
                        className="TextField"
                        value={data.passwordDurationInDays}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'numeric',
                            shrink: true,
                        }}
                    />
                </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', border: '1px solid #d3d3d3', padding: 5, borderRadius: 5, marginTop: 20}}>
                <div style={{marginTop:1}}>
                    <Checkbox
                        id="enableLockoutAfterFailedLogin"
                        checked={data.enableLockoutAfterFailedLogin}
                        onChange={(event, value) => onFieldChange( event.target.checked, event.target.id)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    /> Enable Lockout After Failed attempts
                </div>
                <div style={{marginLeft:50, marginTop: 5}}>
                    <TextField
                        // style={{marginTop: 5}}
                        disabled={!data.enableLockoutAfterFailedLogin}
                        id="maxNbOfFailedLogin" 
                        label="Max Number of failed attempts before locking the account" 
                        variant="outlined"
                        className="TextField"
                        value={data.maxNbOfFailedLogin}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'numeric',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:50, marginTop: 10}}>
                    <TextField
                        // style={{marginTop: 5}}
                        disabled={!data.enableLockoutAfterFailedLogin}
                        id="lockoutDuration" 
                        label="Lockout duration in minutes" 
                        variant="outlined"
                        className="TextField"
                        value={data.lockoutDuration}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'numeric',
                            shrink: true,
                        }}
                    />
                </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', border: '1px solid #d3d3d3', padding: 5, borderRadius: 5, marginTop: 20}}>
                <div style={{marginTop:20, marginLeft:10}}>
                    <TextField
                        id="minimumPasswordLength" 
                        label="Minimum Password Length" 
                        variant="outlined"
                        className="TextField"
                        value={data.minimumPasswordLength}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'numeric',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginTop:1}}>
                    <Checkbox
                        id="enableTFA"
                        checked={data.enableTFA}
                        onChange={(event, value) => onFieldChange( event.target.checked, event.target.id)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    /> Enable TFA
                </div>
            </div>
        </div>
    );
   
}

export default PasswordPolicySettings;